import { useQuery } from '@tanstack/react-query';
import { useTelegram } from './useTelegram';
import { bootstrapSession } from '../lib/session';

/** Friendly device name from the Telegram platform, for the Sessions screen. */
function deviceLabel(platform: string): string {
  const map: Record<string, string> = {
    ios: 'iPhone',
    android: 'Android',
    macos: 'Mac',
    tdesktop: 'Telegram Desktop',
    weba: 'Telegram Web',
    webk: 'Telegram Web',
    web: 'Telegram Web',
    unigram: 'Unigram',
  };
  return map[platform] ?? 'Telegram';
}

/** Exchanges Telegram initData for a session token on app open (real Telegram
 *  only). `token` is null in dev/browser (no initData) — screens fall back to
 *  the local profile store there. */
export function useSession() {
  const { initData, status, platform } = useTelegram();
  const ready = status === 'ready' && !!initData;

  const q = useQuery({
    queryKey: ['session'],
    enabled: ready,
    queryFn: () => bootstrapSession(initData, platform || undefined, deviceLabel(platform)),
    staleTime: Infinity,
    retry: 1,
  });

  return {
    token: q.data ?? null,
    /** In a real Telegram client (initData present) — i.e. the API is in play. */
    ready,
    /** Bootstrapping the session token. */
    loading: ready && q.isLoading,
  };
}
